import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Configurer from "../components/Configurer";
import StagesManager from "../components/StagesManager";
import { checkPermission, checkTranslation, pathMaker, translate } from "../utils/useful";
import PageStatusViewer from "../components/PageStatusViewer";
import AdminDashboard from "./admin/AdminDashboard";
import { adminPages, adminSections } from "../variables/adminPages";
import HomeDashboards from "./admin/HomeDashboards";
import AdminWidgetsPage from "./admin/AdminWidgetsPage";
import { adminWidgets, test } from "../variables/adminWidgets";
import UserDashboards from "./UserDashboards";
import UserWidgetsPage from "./UserWidgetsPage";
import { siteConfig, siteTheme } from "../variables/config";
import {
    createLocalRolePreviewUser,
    isLocalRolePreviewSession,
} from "../utils/localRolePreview";

class Admin extends React.Component {

    state = {
        modules: [],
        branches: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
        ],
        tabs: [
            // { pageHome: true, description: '{{lang}}Documents Records Platform', showInDashboard: true, title: '{{lang}}Documents Records', key: 'document', image: '/images/icons/records.png', page: 'document', defaultAccess: true },

            // { pageHome: true, description: '{{lang}}Energy Platform', showInDashboard: true, title: '{{lang}}Energy', key: 'energy', image: '/images/icons/booster.png', page: 'energy', defaultAccess: true, commingSoon: false },

            // { pageHome: true, description: '{{lang}}Carbon Platform', showInDashboard: true, title: '{{lang}}Carbon', key: 'carbon', image: '/images/icons/reduction.png', page: 'carbon', defaultAccess: true, commingSoon: false },

            { description: 'تنظیمات مدیریتی پلتفرم', showInDashboard: true, title: '{{lang}}Settings', key: 'settings', image: '/images/kheiry/settings1.png', page: 'settings', defaultAccess: true, commingSoon: false },

        ],
        activeWidgets: 'adminPages',
        testUserType: null, // For test environment user type switching
    }


    componentDidMount() {

        this.props.setHeader({ title: '{{lang}}Dashboard' })
        if (siteConfig.testEnv && isLocalRolePreviewSession(this.props.user?.info)) {
            this.setState({ testUserType: this.props.user.info.userType })
        }
        // console.log('on home', this.props.myHeaders)
        // this.checkAdmin()
    }
    checkAdmin = (page) => {

        let path = pathMaker(page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }
    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(this.state.oldPath)
        // console.log(this.props.location.pathname)
        if (this.state.oldPath != this.props.location.pathname) {
            this.setState({ oldPath: this.props.location.pathname }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        let def = ''
        let pageType = null
        let pageInfo = null
        // console.log(window.location.pathname)
        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            if (path == '/') {
                def = pathname[index + 1]
            }
        });

        // console.log(def)

        let pageIsValid = false

        Object.values(adminPages).forEach(page => {
            if (page.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page
            }
        });
        if (!def || def == '' || checkPermission('admin.' + pageInfo.key) || !pageInfo || !pageInfo.permissionRules || (checkPermission(pageInfo.permissionRules))) {

            if (!def) {
                def = ''
            }
            // console.log(def)
            if (def === '') {
                pageType = ''
                pageIsValid = true
            }
            if (pageIsValid) {
                // this.state.page = page
                this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                    this.setState({ path: def, }, () => {
                        // stageManager only exists for admin view; veterinarian/horseBreeder render UserDashboards without StagesManager
                        if (this.stageManager) {
                            this.stageManager.changeStage(pageType, () => {
                                window.scrollTo({ top: 0, behavior: 'smooth' })
                            })
                            setTimeout(() => {
                                this.setState({ page: null }, () => {

                                    this.setState({ page: pageInfo })
                                })
                            }, 400);
                        }
                    })
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    changePage = (page) => {

        let path = pathMaker(page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }


    showMenu() {
        return (
            <div>
                <div className="text-center py-3">
                    <img src="/images/male.png" width="70px" style={{ borderRadius: 100 }} alt="" />
                    <p className="font-bold mt-1">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                </div>


            </div>
        )
    }

    navigationBackButton(action) {
        return (
            <div className="flexc mx-2 h-100 d-md-none">
                <button className="p-0 m-0 flexcc h-100" onClick={() => this.mobileMenuModal.showModal()} style={{ backgroundColor: '#f2f6f8dd', color: '#334455', fontWeight: 'bold' }}>
                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                </button>
            </div>
        )
    }

    informParent = (message) => {
        if (message == 'permissionDenied') {
            this.setState({ pageStatus: 401 })
        }
        if (message == 'notFound') {
            this.setState({ pageStatus: 404 })
        }
    }

    handlePlatformWidgets = (data) => {
        this.setState({ activeWidgets: data.key }, () => {
            // test(this.state.activeWidgets)
            console.log('this.state.activeWidgets', this.state.activeWidgets)
        })
    }

    switchTestUserType = (type) => {
        if (isLocalRolePreviewSession(this.props.user?.info)) {
            const previewUser = createLocalRolePreviewUser(type)
            if (previewUser) {
                this.props.actions.setUser(previewUser, null, true)
            }
        }

        this.setState({ testUserType: type }, () => {
            // Force stage change to update the view
            if (this.stageManager) {
                const effectiveUserType = siteConfig.testEnv && this.state.testUserType 
                    ? this.state.testUserType 
                    : this.props.user?.info?.userType
                
                const isAdmin = checkPermission('admin') || effectiveUserType === 'admin'
                
                if (!isAdmin && (effectiveUserType === 'veterinarian' || effectiveUserType === 'horseBreeder')) {
                    // User dashboard
                    this.stageManager.changeStage('', () => {
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    })
                } else {
                    // Admin dashboard
                    this.stageManager.changeStage('', () => {
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    })
                }
            }
        })
    }

    render() {
        // Check if user is admin or regular user
        // In test environment, use testUserType if set
        const testEnv = siteConfig.testEnv
        const effectiveUserType = testEnv && this.state.testUserType 
            ? this.state.testUserType 
            : this.props.user?.info?.userType
        
        const isAdmin = checkPermission('admin') || effectiveUserType === 'admin'
        const userType = effectiveUserType
        
        let admin = isAdmin
        let variables = {
            permissionRoot: 'admin.' + (this.state.page?.permissionParent ?? this.state.page?.key)
        }

        // Test environment user type switcher buttons
        const testUserTypeButtons = testEnv ? (
            <div className="w-100 p-3 mb-3" style={{
                background: 'linear-gradient(135deg, #10453d15, #ffffff)',
                border: '2px solid #10453d40',
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
                <p className="mb-2" style={{ fontSize: 14, fontWeight: 600, color: '#10453d' }}>
                    {translate('Test Environment - Switch User Type')}:
                </p>
                <div className="d-flex gap-2 flex-wrap">
                    <button
                        onClick={() => this.switchTestUserType('admin')}
                        style={{
                            background: this.state.testUserType === 'admin' 
                                ? `linear-gradient(135deg, ${siteTheme.primaryColors.main1} 0%, ${siteTheme.primaryColors.main1} 75%, ${siteTheme.primaryColors.main2} 100%)`
                                : `linear-gradient(135deg, ${siteTheme.primaryColors.main3}20, #ffffff)`,
                            border: `2px solid ${this.state.testUserType === 'admin' ? siteTheme.primaryColors.main1 : siteTheme.primaryColors.main3 + '60'}`,
                            borderRadius: 8,
                            padding: '8px 20px',
                            fontSize: 13,
                            fontWeight: 600,
                            color: this.state.testUserType === 'admin' ? '#fff' : siteTheme.primaryColors.main1,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: this.state.testUserType === 'admin' ? `0 4px 12px ${siteTheme.primaryColors.main1}40` : 'none'
                        }}
                    >
                        {translate('Admin')}
                    </button>
                    <button
                        onClick={() => this.switchTestUserType('veterinarian')}
                        style={{
                            background: this.state.testUserType === 'veterinarian' 
                                ? `linear-gradient(135deg, ${siteTheme.primaryColors.main1} 0%, ${siteTheme.primaryColors.main1} 75%, ${siteTheme.primaryColors.main2} 100%)`
                                : `linear-gradient(135deg, ${siteTheme.primaryColors.main3}20, #ffffff)`,
                            border: `2px solid ${this.state.testUserType === 'veterinarian' ? siteTheme.primaryColors.main1 : siteTheme.primaryColors.main3 + '60'}`,
                            borderRadius: 8,
                            padding: '8px 20px',
                            fontSize: 13,
                            fontWeight: 600,
                            color: this.state.testUserType === 'veterinarian' ? '#fff' : siteTheme.primaryColors.main1,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: this.state.testUserType === 'veterinarian' ? `0 4px 12px ${siteTheme.primaryColors.main1}40` : 'none'
                        }}
                    >
                        {translate('Veterinarian')}
                    </button>
                    <button
                        onClick={() => this.switchTestUserType('horseBreeder')}
                        style={{
                            background: this.state.testUserType === 'horseBreeder' 
                                ? `linear-gradient(135deg, ${siteTheme.primaryColors.main1} 0%, ${siteTheme.primaryColors.main1} 75%, ${siteTheme.primaryColors.main2} 100%)`
                                : `linear-gradient(135deg, ${siteTheme.primaryColors.main3}20, #ffffff)`,
                            border: `2px solid ${this.state.testUserType === 'horseBreeder' ? siteTheme.primaryColors.main1 : siteTheme.primaryColors.main3 + '60'}`,
                            borderRadius: 8,
                            padding: '8px 20px',
                            fontSize: 13,
                            fontWeight: 600,
                            color: this.state.testUserType === 'horseBreeder' ? '#fff' : siteTheme.primaryColors.main1,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: this.state.testUserType === 'horseBreeder' ? `0 4px 12px ${siteTheme.primaryColors.main1}40` : 'none'
                        }}
                    >
                        {translate('Horse Breeder')}
                    </button>
                </div>
            </div>
        ) : null

        // If user is not admin, show user dashboard
        // console.log('userTypaaaaaae', userType,isAdmin)
        // if (!isAdmin && (userType === 'veterinarian' || userType === 'horseBreeder')) {
        if ((userType === 'veterinarian' || userType === 'horseBreeder')) {
            return (
                <Configurer
                    settingsInfo={{
                        showFooter: true, showTabBar: true, showHeader: true, headerTitle: translate('Dashboard'), button: {},
                        titleButtons: [this.navigationBackButton(this.props.lastStage)]
                    }}
                    title={translate('Dashboard')}
                    description={translate('User Dashboard')}
                    className="p-0 min-full-height w-100"
                    ref={el => this.configurer = el}
                    style={{ backgroundColor: '#f3f3f3' }}
                >
                    <PageStatusViewer status={this.state.pageStatus}>
                        <div className="w-100 h-100" style={{ backgroundColor: '#f3f3f3' }}>
                            <div className="row m-0">
                                <div className="col-12 p-0" style={{}}>
                                    {testUserTypeButtons}
                                    <div key={`user-content-${userType}`}>
                                        <UserDashboards 
                                            key={`user-dashboards-${userType}`}
                                            activeWidgets={this.state.activeWidgets} 
                                            handlePlatformWidgets={this.handlePlatformWidgets} 
                                            pages={this.state.pages}
                                            testUserType={this.state.testUserType} 
                                            home={true} 
                                            user={{ ...this.props.user, info: { ...this.props.user?.info, userType: userType } }} 
                                            modules={this.state.tabs} 
                                            changePage={this.changePage} 
                                            title={translate('Dashboard')} 
                                            description={translate('User Dashboard')} 
                                            route={""} 
                                        />
                                        <UserWidgetsPage 
                                            key={`user-widgets-${userType}`}
                                            widget={this.state.activeWidgets} 
                                            pages={this.state.pages}
                                            testUserType={this.state.testUserType} 
                                            user={{ ...this.props.user, info: { ...this.props.user?.info, userType: userType } }} 
                                            modules={this.state.modules} 
                                            changePage={this.changePage} 
                                            title={translate("Widgets")} 
                                            description={translate("User Widgets")} 
                                            route={"user"} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PageStatusViewer>
                </Configurer>
            )
        }

        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},
                    titleButtons: [this.navigationBackButton(this.props.lastStage)]

                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 min-full-height w-100"
                ref={el => this.configurer = el}
                style={{ backgroundColor: '#f3f3f3' }}

            >

                <PageStatusViewer status={this.state.pageStatus}>
                    <div className="w-100 h-100" style={{ backgroundColor: '#f3f3f3' }}>
                        <div className="row m-0">
                            {testUserTypeButtons}
                            <div className="col-12 p-0" style={{}}>

                                <StagesManager ref={el => this.stageManager = el} fast={true} key={`admin-dashboard-${userType}`}>

                                    <HomeDashboards key={`admin-dashboards-${userType}`} admin={admin} activeWidgets={this.state.activeWidgets} handlePlatformWidgets={this.handlePlatformWidgets} pages={this.state.pages} stage={0} home={true} user={this.props.user} modules={this.state.tabs} stageName={''} changePage={this.changePage} title={'IHP'} description={translate('پلتفرم کسب و کار')} route={""} />

                                </StagesManager>

                            </div>
                        </div>
                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin);
